import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var cart = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13.054",
  height: "15.067",
  viewBox: "0 0 13.054 15.067",
  children: /*#__PURE__*/_jsxs("g", {
    id: "bag",
    transform: "translate(-3.005 -0.995)",
    children: [/*#__PURE__*/_jsx("path", {
      id: "Path_7734",
      "data-name": "Path 7734",
      d: "M16.056,13.1l-.91-8.743a1.5,1.5,0,0,0-1.5-1.351H11.991a2.511,2.511,0,0,0-4.921,0H5.413a1.5,1.5,0,0,0-1.5,1.35L3,13.1v.05a2.916,2.916,0,0,0,2.91,2.913h7.231a2.916,2.916,0,0,0,2.913-2.913A.446.446,0,0,0,16.056,13.1ZM9.531,2a1.509,1.509,0,0,1,1.421,1H8.11A1.509,1.509,0,0,1,9.531,2Zm3.616,13.056H5.915a1.908,1.908,0,0,1-1.908-1.884l.908-8.712a.5.5,0,0,1,.5-.452h8.235a.5.5,0,0,1,.5.452l.9,8.712a1.908,1.908,0,0,1-1.908,1.884Z",
      fill: "#fff"
    }), /*#__PURE__*/_jsx("path", {
      id: "Path_7735",
      "data-name": "Path 7735",
      d: "M15.519,11a.5.5,0,0,0-.5.5A1.506,1.506,0,1,1,12,11.5a.5.5,0,0,0-1,0,2.511,2.511,0,1,0,5.022,0A.5.5,0,0,0,15.519,11Z",
      transform: "translate(-3.98 -4.981)",
      fill: "#fff"
    })]
  })
});
export var check = /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "18.2",
  viewBox: "0 0 14 10.2",
  children: /*#__PURE__*/_jsx("path", {
    id: "check",
    d: "M18.7,7.2a.967.967,0,0,0-1.4,0L9.8,14.7,6.7,11.6A.99.99,0,0,0,5.3,13l3.8,3.8a.967.967,0,0,0,1.4,0l8.2-8.2a.967.967,0,0,0,0-1.4Z",
    transform: "translate(-5 -6.9)",
    fill: "#fff"
  })
});
export var Coin = function Coin() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.95 45.95",
    className: "h-4 w-4 shrink-0 lg:h-6 lg:w-6",
    children: [/*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "coin-gradient-1",
        x1: "0",
        y1: "22.98",
        x2: "45.95",
        y2: "22.98",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#fdc977"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".62",
          stopColor: "#feefd7"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".67",
          stopColor: "#faead0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".73",
          stopColor: "#f0ddbe"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".81",
          stopColor: "#e1c8a1"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".9",
          stopColor: "#cbaa78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#af8545"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "coin-gradient-2",
        x1: "3.26",
        y1: "22.98",
        x2: "42.7",
        y2: "22.98",
        children: [/*#__PURE__*/_jsx("stop", {
          offset: "0",
          stopColor: "#fdc977"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".62",
          stopColor: "#feefd7"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".67",
          stopColor: "#faead0"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".73",
          stopColor: "#f0ddbe"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".81",
          stopColor: "#e1c8a1"
        }), /*#__PURE__*/_jsx("stop", {
          offset: ".9",
          stopColor: "#cbaa78"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#af8545"
        })]
      })]
    }), /*#__PURE__*/_jsxs("g", {
      children: [/*#__PURE__*/_jsx("path", {
        fill: "url(#coin-gradient-1)",
        d: "M22.98,0C10.29,0,0,10.29,0,22.98s10.29,22.98,22.98,22.98,22.98-10.29,22.98-22.98S35.67,0,22.98,0ZM22.98,43.2c-11.17,0-20.22-9.05-20.22-20.22S11.81,2.76,22.98,2.76s20.22,9.05,20.22,20.22-9.05,20.22-20.22,20.22Z"
      }), /*#__PURE__*/_jsx("path", {
        fill: "url(#coin-gradient-2)",
        d: "M22.98,3.26C12.1,3.26,3.26,12.1,3.26,22.98s8.85,19.72,19.72,19.72,19.72-8.85,19.72-19.72S33.85,3.26,22.98,3.26ZM30.42,34.43l-7.44-5.41-7.44,5.41,2.84-8.75-7.44-5.41h9.2l2.84-8.75,2.84,8.75h9.2l-7.44,5.41,2.84,8.75Z"
      })]
    })]
  });
};